module.exports = __webpack_public_path__ + "static/media/jabberwocky.a821e9ce.jpg";